<template>
  <div class="taskDetail">
    <van-sticky>
      <van-tabs
        v-model="active"
        swipeable
        title-active-color="#fab13e"
        color="#fab13e"
      >
        <van-tab
          v-for="(item,index) in menu"
          :name="item"
          :key="index"
          :title="item"
        ></van-tab>
      </van-tabs>
    </van-sticky>

    <div
      v-if="active=='组织关系'"
      style="padding: 0 5px;"
    >
      <van-cell
        is-link
        class=""
        icon="manager"
        :value="itemSon.num_person+'人'"
        @click="toTaskDesc(itemSon) "
        v-for="(itemSon, index2) in listData"
        :name="index2"
        :key="index2"
      >

        <div
          slot="title"
          v-if="itemSon.name!='' && itemSon.name!=null"
        >
          <span class="text-grey">小队长:{{itemSon.name}}</span>
        </div>
        <div
          slot="title"
          v-else
        >
          <span class="text-grey">小队长:<span style="color: #bbb;">暂未分配</span></span>
        </div>
      </van-cell>
    </div>
    <!-- <div v-if="active=='任务'" class="">
			<myTask :camp_id="camp_id" :user_id="user_id" :type="type"></myTask>
		</div>
		<div v-else-if="active=='异常'" class="">
			<myReporting :camp_id="camp_id" :user_id="user_id" :type="type"></myReporting>
		</div> -->
  </div>
</template>
<script>
import myTask from '../../publicComponents/myTask'
import myReporting from '../../publicComponents/myReporting'
export default {
  components: {
    myTask,
    myReporting,
  },
  data() {
    return {
      listChildren: '',
      active: '',
      // menu:['任务','异常'],
      menu: ['组织关系'],
      camp_id: '',
      user_id: '',
      // type: '',
      listData: '',
    }
  },
  methods: {
    // onClick(name) {
    //   let query =
    //     'camp_id=' +
    //     this.camp_id +
    //     '&user_id=' +
    //     this.user_id +
    //     '&type=' +
    //     this.type +
    //     '&tab=' +
    //     name
    //   this.$router.replace('/subPackages/myTask/taskDetail2?' + query)
    // },
  },
  methods: {
    loadData() {
      // this.joyPageStatus = 'loading'
      try {
        this.$axios
          .get(
            'team/tree?camp_id=' + this.camp_id + '&partner_id=' + this.user_id
          )
          .then((res) => {
            // this.joyPageStatus = 'success'
            if (res.data.code == 200) {
              this.listData = res.data.data
            }
          })
          .catch(function (error) {
            // this.joyPageStatus = 'fail'
          })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    toTaskDesc(item) {
      console.log(item)
      if (item.type == 3) {
        // 里面有任务,异常
        this.$router.push({
          path: '/subPackages/myTask/taskDetail',
          query: {
            camp_id: item.id,
            user_id: item.user_id,
            type: item.type,
          },
        })
      }
    },
  },
  created() {
    const that = this
    that.camp_id = this.$route.query.camp_id
    that.user_id = this.$route.query.user_id
    this.loadData()

    // that.type = this.$route.query.type
    // if (this.$route.query.tab) {
    //   that.active = this.$route.query.tab
    // } else {
    //   that.active = '任务'
    // }
  },
  activated() {
    const that = this
    that.camp_id = this.$route.query.camp_id
    that.user_id = this.$route.query.user_id
    // that.type = this.$route.query.type
    // if (this.$route.query.tab) {
    //   that.active = this.$route.query.tab
    // } else {
    //   that.active = '任务'
    // }
  },
}
</script>


